import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";

function Contact() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const faqs = [
    {
      title: "Track My Order",
      body: `If you have received a dispatch email then your order is on the way. Enter your order number and email/postcode on the tracking page to view latest updates. Deliveries typically occur 7 days a week between 8am and 9pm.`,
    },
    {
      title: "Returns Information",
      body: `To start a return click here to return an order through our returns portal. For more information on returns and our returns policy, please visit our Returns Information Page.`,
    },
    {
      title: "Delivery Options & Timeframes",
      body: `See our Delivery Information page for details on delivery options, costs and cut-off times. Some services are subject to postcode restrictions.`,
    },
  ];

 

  return (
    <div className="contact">
      <Header />

      <main>
        <div className="contact-inner">
          <h1>Contacting Us</h1>
          <p className="lead">
            Our teams are waiting to help you with any questions you may have.
            Please have your order number to hand so that we can process your
            request as efficiently as possible. We're sorry we don't have a
            phone number to call.
          </p>

          <section className="faq">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-list">
              {faqs.map((f, i) => (
                <div className="faq-item" key={i}>
                  <button className="faq-head" onClick={() => toggle(i)}>
                    <span>{f.title}</span>
                    <span className="chev">{openIndex === i ? "▴" : "▾"}</span>
                  </button>
                  {openIndex === i && (
                    <div className="faq-body">
                      <p>{f.body}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
